import { landingPageQuery } from '~/components/homehub/Landing/landingPage.gql'
import { NullServicer, NullPartner, Profile } from '~/components/homehub/Landing/Servicer/nullProfile.js'
import gql from 'graphql-tag'
import { cloneDeep } from 'lodash'

export default {
  name: 'fetchServicerMixin',
  data () {
    return {
      servicer: this.$store?.servicer || new NullServicer(),
      partner: this.$store?.partner || new NullPartner(),
      loadingFetchServicerData: this.$store?.viewed?.length === 0 || false
    }
  },
  apollo: {
    // runs when custom domain is present without a sac
    noSacData: {
      query: gql` query landingPageQueryNoSac($code: String) {
        noSacData: public {
          organization(servicer_activation_code: $code) {
            auth_flow_config_setting_terms_and_conditions_enabled
            auth_flow_config_setting_terms_and_conditions_request_html
            auth_flow_config_setting_loan_access_request_html
            feature_setting_share_borrower_info_consent
            feature_setting_custom_consent_checkbox
            feature_setting_generic_organization_footer
            effective_logo_url
            effective_app_icon_url
            effective_website_disclaimer
            state_lics {
              id
              state_license_val
              license_number
              state_license {
                id
                state
                state_code
                license
                value
              }
            }
            effective_terms_of_use_link
            effective_privacy_policy_link
            effective_company_nmls
            effective_eh_logos {
              id
              typeId
              name
              iconUrl
              iconName
              accountType
              ownerId
              ownerType
            }
            effective_default_servicer_profile {
              is_discoverable
              default_code
              default_sac_id
              feature_setting_ncino_privacy_policy
              feature_setting_login_only_when_undiscoverable
              effective_company_name
              company_has_data_sale
              company_has_twilio_messaging_service
              consumer_access_link
              lead_gen_setting_landing_page_title_text
            }
            organization_setting_borrower_support_settings
            organization_setting_twilio_sms_enabled
          }
          organization_login_settings {
            sso_setting_loan_officer_sso_label
            sso_setting_loan_officer_sso_v2
            sso_setting_borrower_sso_enabled
            sso_setting_borrower_sso_label
            sso_setting_borrower_sso_hide_username_and_password_login
            effective_website_disclaimer
            has_sso_login_target_url
          }
        }
      }`,
      skip () {
        return (
          !!(this.$route.params.code || this.$store.servicer?.email ||
            this.$store.effectiveLogoUrl || this.$store.effectiveAppIconUrl ||
            this.$store.defaultCode || this.$store.defaultSacId)
        )
      },
      result ({ data }) {
        this.$store.effectiveLogoUrl = data.noSacData?.organization?.effective_logo_url
        this.$store.effectiveAppIconUrl = data.noSacData?.organization?.effective_app_icon_url
        this.$store.defaultCode = data.noSacData?.organization?.effective_default_servicer_profile?.default_code
        this.$store.defaultSacId = data.noSacData?.organization?.effective_default_servicer_profile?.default_sac_id
        this.$store.orgLoginSettings = data.noSacData?.organization_login_settings
        this.$store.termsAndConditionsEnabled = data.noSacData?.organization?.auth_flow_config_setting_terms_and_conditions_enabled
        this.$store.termsAndConditionsRequestHtml = data.noSacData?.organization?.auth_flow_config_setting_terms_and_conditions_request_html
        this.$store.loanAccessRequestHtml = data.noSacData?.organization?.auth_flow_config_setting_loan_access_request_html
        this.$store.shareBorrowerInfoConsent = data.noSacData?.organization?.feature_setting_share_borrower_info_consent
        this.$store.customCheckboxConsent = data.noSacData?.organization?.feature_setting_custom_consent_checkbox
        this.$store.genericOrganizationFooter = data.noSacData?.organization?.feature_setting_generic_organization_footer
        this.$store.borrowerSupportSettings = data.noSacData?.organization?.organization_setting_borrower_support_settings
        this.$store.twilioEnabled = data.noSacData?.organization?.organization_setting_twilio_sms_enabled
        this.$store.footerInfo = {
          state_lics: data.noSacData?.organization?.state_lics,
          effective_website_disclaimer: data.noSacData?.organization?.effective_website_disclaimer,
          effective_terms_of_use_link: data.noSacData?.organization?.effective_terms_of_use_link,
          effective_privacy_policy_link: data.noSacData?.organization?.effective_privacy_policy_link,
          effective_company_nmls: data.noSacData?.organization?.effective_company_nmls,
          consumer_access_link: data.noSacData?.organization?.effective_default_servicer_profile?.consumer_access_link,
          effectiveEhLogos: data.noSacData?.organization?.effective_eh_logos
        }
        this.$store.servicer = data.noSacData?.organization?.effective_default_servicer_profile
        this.$store.leadGenLandingPageTitleText = data.noSacData?.organization?.lead_gen_setting_landing_page_title_text
        this.loadingFetchServicerData = false
      },
      error ({ error }) {
        this.$sentry.captureException(error)
        this.loadingFetchServicerData = false
      }
    },
    publicData: {
      query: landingPageQuery,
      variables () {
        return {
          code: this.$route.params.code || this.$store?.servicer?.email
        }
      },
      skip () {
        return (
          (this.servicer instanceof NullServicer === false &&
            this.$store?.servicer instanceof NullServicer === false) ||
          (!this.$route.params.code && !this.$store?.servicer?.email)
        )
      },
      result ({ data }) {
        const dataCopy = cloneDeep(data) // prevents mutation of apollo cache (publicData.servicer_profile)
        const servicerResponse = dataCopy.publicData.servicer_profile
        const partnerResponse = dataCopy.publicData.partner
        const parentOrganizationResponse = dataCopy.publicData.organization
        this.$store.orgLoginSettings = dataCopy.publicData.organization_login_settings
        this.$store.company = dataCopy.publicData.company
        this.servicer = this.$store.servicer = dataCopy.publicData.servicer_profile

        if (servicerResponse) {
          this.$store.servicer = this.servicer = new Profile(servicerResponse)

          if (parentOrganizationResponse) {
            this.$store.servicer.parentOrganization = parentOrganizationResponse

            if (parentOrganizationResponse.effective_logo_url) {
              this.$store.effectiveLogoUrl = parentOrganizationResponse.effective_logo_url
            }
            if (parentOrganizationResponse.effective_app_icon_url) {
              this.$store.effectiveAppIconUrl = parentOrganizationResponse.effective_app_icon_url
            }
            if (this.$store.servicer.parentOrganization.state_lics) {
              this.$store.servicer.parentOrganization.state_lics = this.$store.servicer.parentOrganization.state_lics.map(sl => {
                return { state: sl.state_license.state_code, value: sl.state_license_val }
              })
            }
            if (this.$store.servicer.state_lics) {
              this.$store.servicer.state_lics = this.$store.servicer.state_lics.map(sl => {
                return { state: sl.state_license.state_code, value: sl.state_license_val }
              })
            }
            if (this.$store.servicer.state_lics.length === 0 && this.$store.servicer.parentOrganization && this.$store.servicer.parentOrganization.state_lics) this.$store.servicer.state_lics = this.$store.servicer.parentOrganization.state_lics
          }
        }

        if (partnerResponse) {
          this.$store.partner = this.partner = new Profile(partnerResponse)
        }
        this.loadingFetchServicerData = false
      },
      error ({ error }) {
        this.$sentry.captureException(error)
        this.loadingFetchServicerData = false
      }
    }
  }
}
